module.exports = __webpack_public_path__ + "media/components/home/unlock-vecteezy/img/join-pro-mobile-ffd2a3c066b22ad79db033b777004b8b.jpg";